import template from './openBanking.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, eventService) {
      'ngInject';

      const ctrl = this;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onDialogOpenBanking((params) => {
          $mdDialog
            .show({
              targetEvent: params?.event || '',
              locals: {
                contacts: params?.contacts || [],
                openBankingData: params?.openBankingData || [],
                openBankingDataType: params?.openBankingDataType || '',
                ticket: params?.ticket || {}
              },
              template,
              controllerAs: '$ctrl',
              multiple: true,
              controller(contacts, openBankingData, openBankingDataType, ticket) {
                const self = this;
                self.contacts = contacts;
                self.openBankingData = openBankingData;
                self.openBankingDataType = openBankingDataType;
                self.ticket = ticket;
                self.currentData = [];
                self.selectedData = [];

                if (self.openBankingDataType) {
                  const len = self.openBankingData?.length || 0;
                  for (let d = 0; d < len; d += 1) {
                    const oBD = self.openBankingData[d];
                    const currentData = _.pick(oBD, [self.openBankingDataType]);
                    self.currentData = self.currentData.concat(
                      currentData[self.openBankingDataType]
                    );
                  }
                }

                self.getTitleAndIcon = () => {
                  let title = '';
                  let icon = '';
                  switch (self.openBankingDataType) {
                    case 'income':
                      title = 'Open banking - Income data';
                      icon = 'monetization_on';
                      break;
                    case 'expenses':
                      title = 'Open banking - Expenses data';
                      icon = 'shopping_cart';
                      break;
                    case 'assets':
                      title = 'Open banking - Assets data';
                      icon = 'store';
                      break;
                    case 'liabilities':
                      title = 'Open banking - Liabilities data';
                      icon = 'account_balance';
                      break;
                    default:
                      title = 'Open banking data';
                      icon = 'source';
                      break;
                  }
                  return { title, icon };
                };

                self.select = (data) => {
                  self.selectedData = [];
                  const selData = _.isArray(data) ? data : [data];
                  const len = selData?.length || 0;
                  for (let i = 0; i < len; i += 1) {
                    const item = selData[i];
                    const idx = _.findIndex(self.selectedData || [], (d) => d?.id === item?.id);
                    if (idx === -1) {
                      self.selectedData.push(item);
                    }
                  }
                };

                self.confirm = () => {
                  if (self.selectedData?.length) {
                    $mdDialog.hide({
                      selectedData: self.selectedData,
                      type: self.openBankingDataType
                    });
                  }
                };

                self.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((res) => {
              if (res.selectedData?.length && res.type) {
                const data = {
                  selectedData: res.selectedData,
                  type: res.type
                };
                ctrl.onFinished({ data });
              }
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
